import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { SaveTemplateDialogData } from '@shared/interfaces/save-template-dialog.interface';

@Component({
  selector: 'app-save-template-dialog',
  templateUrl: './save-template-dialog.component.html',
  styleUrls: ['./save-template-dialog.component.scss'],
})
export class SaveTemplateDialogComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly dialogRef = inject(MatDialogRef<SaveTemplateDialogComponent>);

  data: SaveTemplateDialogData = inject(MAT_DIALOG_DATA);
  form!: FormGroup;

  ngOnInit(): void {
    this.initForm();
  }

  onSave(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    // Raw value to include the checkbox even when it is disabled
    this.dialogRef.close(this.form.getRawValue());
  }

  onContinue(): void {
    this.dialogRef.close({
      templateName: '',
      shouldClone: false,
      shouldContinue: true,
    });
  }

  getTemplateNameText(): string {
    let text = this.data.hasChanges ? 'You have unsaved changes in this report.<br /><br />' : '';
    text += 'Enter a name for this template and save it to preserve your changes.';
    return text;
  }

  getShouldCloneText(): string {
    return "If selected, this will create a clone of the current template instead of overwriting it when you click on 'Save'";
  }

  getDialogTitle(): string {
    return this.data.hasChanges ? 'Unsaved Changes' : 'Confirm Save';
  }

  private initForm() {
    this.form = this.fb.group({
      templateName: this.fb.control<string | null>(this.data.isGlobal ? null : this.data.templateName, [
        Validators.required,
        Validators.minLength(3),
      ]),
      shouldClone: this.fb.control<boolean>({ value: this.data.isGlobal, disabled: this.data.isGlobal }),
    });
  }
}
